import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { PainSection } from './components/PainSection';
import { PackOverview } from './components/PackOverview';
import { Bonos } from './components/Bonos';
import { Testimonials } from './components/Testimonials';
import { CostTable } from './components/CostTable';
import { Pricing } from './components/Pricing';
import { KitComparison } from './components/KitComparison';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { UrgencyBlock } from './components/UrgencyBlock';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans" data-id="element-0" data-mp="3ij65ue8glt9z">
      <Hero data-id="element-1" data-mp="3mlj98vzqhf3l" />
      <main data-id="element-2" data-mp="3ml14faz09sk2">
        <TrustBar data-id="element-3" data-mp="3mkrchhuehbbq" />
        <PainSection data-id="element-4" data-mp="3mk84otygs3bf" />
        <PackOverview data-id="element-5" data-mp="3mjg9hk8s47lo" />
        <Bonos data-id="element-6" data-mp="3rc9ca2kot5v4" />
        <Testimonials data-id="element-7" data-mp="3rbrayrj641gc" />
        <CostTable data-id="element-8" data-mp="3rdatypw7kqlt" />
        <Pricing data-id="element-9" data-mp="3rd1azm9kzjpm" />
        <KitComparison data-id="element-10" data-mp="3reltgdimfc74" />
        <MoreTestimonials data-id="element-11" data-mp="5os92t1uy7l" />
        <Guarantee data-id="element-12" data-mp="4wwnrzgd0hb" />
        <UrgencyBlock data-id="element-13" data-mp="5gbv0xpxarn" />
        <Faq data-id="element-14" data-mp="7svdij4jt6t" />
        <FinalCta data-id="element-15" data-mp="2zl3dbpgpde7f" />
      </main>
      <Footer data-id="element-16" data-mp="2zm4ywnvchj3e" />
      <StickyCta data-id="element-17" data-mp="2zmem63p09c5e" />
      <PurchaseToast data-id="element-18" data-mp="2zmwl5831y4h0" />
      <div className="h-16" aria-hidden="true" data-id="element-19" data-mp="33mouvo46mgny" />
    </div>;
}